/**
 * Filters the menu based on authentication status and other conditions.
 * @param {Array} menu - The menu array to filter.
 * @param {string|null} token - The authentication token.
 * @returns {Array} - The filtered menu array.
 */
export const filteredMenu = (menu, token) => {
  return menu.filter((item) => {
    if (item.isProtected && !token) {
      return false; // Hide protected items if the user is not authenticated
    }
    if ((item.name === "Login" || item.name === "Register") && token) {
      return false; // Hide Login and Register if the user is logged in
    }
    return true; // Show other items
  });
};
